import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, LOCALE_ID, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Register } from '@klickdata/core/auth/src/auth/register.model';
import { AuthService } from '@klickdata/core/auth/src/token/auth.service';
import { CustomerLanding } from '@klickdata/core/customer';
import { ErrorResponse } from '@klickdata/core/http/src/responce/error-responce';
import { Observable, of, Subscription } from 'rxjs';

@Component({
    selector: 'app-signup',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.scss'],
})
export class SignupComponent implements OnDestroy, OnInit {
    register: Register;
    subscription: Subscription;
    error: Observable<ErrorResponse<null>>;
    canRegister = true;
    termsAndPrivacyCounter = 2;
    public customerLanding$: Observable<CustomerLanding>;

    constructor(
        protected auth: AuthService,
        protected router: Router,
        protected route: ActivatedRoute,
        protected location: Location,
        protected cdRef: ChangeDetectorRef,
        @Inject(LOCALE_ID) public localeId: string
    ) {
        this.register = new Register();
    }
    ngOnInit(): void {
        this.customerLanding$ = this.auth.getCustomerLanding();
    }
    onSubmit() {
        this.subscription = this.auth.register(this.register).subscribe(
            () => {
                this.router.navigate(['/home']);
            },
            (err) => (this.error = of(err.error))
        );
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    public handleRegisterBtnAvailability(isChecked: boolean) {
        if (isChecked) {
            this.termsAndPrivacyCounter++;
            this.canRegister = this.termsAndPrivacyCounter < 2 ? false : true;
        } else {
            this.termsAndPrivacyCounter--;
            this.canRegister = this.termsAndPrivacyCounter < 2 ? false : true;
        }
        this.cdRef.markForCheck();
    }
    public routeAfterLogin() {
        const uri = this.route.snapshot.queryParamMap.get('redirect_uri') || this.auth.homeUrl;
        this.router.navigateByUrl(uri);
    }
    public isPrivacyChecked(isChecked: boolean) {
        this.canRegister = isChecked;
        this.cdRef.markForCheck();
    }

    public goBack(): void {
        this.location.back();
    }
}
